export const providerRouter = (onboarding_status: number) => {
    switch(onboarding_status) {
        case 0:
            return '/onboarding/demographics'
        case 1:
            return '/onboarding/locations'
        case 2:
            return '/onboarding/providers'
        case 3:
            return '/onboarding/fee-schedule'
        case 4:
            return '/onboarding/documents'
        case 5:
            return '/onboarding/complete'
        case 6:
        case 7:
        case 8:
            return '/onboarding/pending'
        default: 
            return '/profile'
    }
}